<template>
  <div class="container-page">
    <p class="title-inner">Регионы Китая</p>
    <TableComponent :columns="columns" :storePaths="storePaths" />
  </div>
</template>

<script>
  import { defineComponent } from 'vue';

  import TableComponent from '@/common/components/redesigned/Table/TableComponent.vue';

  import { DIRECTIVES_ACTIONS_NAME, DIRECTIVES_GETTERS_NAME, DIRECTIVES_MUTATIONS_NAME } from '@/store/directives';

  export default defineComponent({
    name: 'RegionsOfChina',
    components: { TableComponent },
    data() {
      return {
        columns: [
          { field: 'name', title: 'Название', width: 800 },
          { field: 'ehdKey', title: 'Ключ ЕХД', width: 100 },
          {
            field: 'isActive',
            title: 'Статус',
            width: 100,
            formatter: (item) => (item.isActive ? 'действ.' : 'не действ.'),
          },
        ],
        storePaths: {
          action: DIRECTIVES_ACTIONS_NAME.getChinaProvinces,
          mutation: DIRECTIVES_MUTATIONS_NAME.setChinaProvincesPage,
          getter: DIRECTIVES_GETTERS_NAME.getChinaProvincesPage,
        },
      };
    },
  });
</script>
